var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrows = function SvgArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6359 11.1859C26.8715 11.0568 27 10.8924 27 10.6986C27 10.3112 26.4431 10 25.7362 10C25.3827 10 25.0614 10.0822 24.8151 10.2172L17.4893 14.3268L10.1849 10.2172C9.93856 10.0822 9.60654 10 9.26381 10C8.55693 10 8 10.3112 8 10.6986C8 10.8924 8.12852 11.0568 8.36415 11.1859L16.5039 15.7534C16.7824 15.9178 17.1251 15.9941 17.5 16C17.8749 16 18.1962 15.9178 18.4853 15.7534L26.6359 11.1859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36415 5.81409C8.12852 5.94325 8 6.10763 8 6.30137C8 6.68885 8.55693 7 9.26381 7C9.61725 7 9.93856 6.91781 10.1849 6.78278L17.5107 2.67319L24.8151 6.78278C25.0614 6.91781 25.3935 7 25.7362 7C26.4431 7 27 6.68885 27 6.30137C27 6.10763 26.8715 5.94325 26.6359 5.81409L18.4961 1.24658C18.2176 1.08219 17.8749 1.00587 17.5 1C17.1251 1 16.8038 1.08219 16.5147 1.24658L8.36415 5.81409Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrows.833d1f2e.svg";
export { ForwardRef as ReactComponent };